import React from "react";
import "./dashboard-navbar.scss";
import { Link } from "react-router-dom";

const DashboardNav = ({ toggleSidebar, isSidebarOpen }) => {
  return (
    <div className="dashboard-navbar">
      <div className="navbar-left">
        <button
          className="sidebar-toggle-btn"
          onClick={toggleSidebar}
          aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
        >
          ☰
        </button>
        <Link to="/">
          <img src="/images/navbar-logo.svg" alt="logo" />
        </Link>
      </div>
      <div className="navbar-right">
        <Link to="" className="nav-link">
          🇵🇰 PKR
        </Link>
        <Link to="" className="nav-link">
          Customer Support
        </Link>
        <Link to="" className="nav-link">
          Find Bookings
        </Link>
        <div className="dropdown profile-dropdown">
          <button
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src="/images/collaborations/team.svg"
              alt="User Avatar"
              className="user-avatar"
            />
          </button>

          <ul
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby="dropdownMenuButton"
          >
            <li>
              <Link className="dropdown-item" to="#">
                1 Room, 2 Adults
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                1 Room, 1 Adult, 1 Child
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                More Options
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DashboardNav;
